export default __webpack_public_path__ + "static/media/cardMedia3.76d82665.jpg";